import { Box } from '@mui/material';
import TemplateBlocks from '../../components/editor/templateEditor/TemplateBlocks';

export const TemplateBlocksSettings = () => {
  return (
    <Box className="h-full w-full flex flex-col overflow-y-auto">
      <TemplateBlocks />
    </Box>
  );
};
